/** 
 * Copyright © INOVUA TRADING.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var DEFAULT_STYLE = {
  position: 'relative',
  verticalAlign: 'middle',
  cursor: 'pointer'
};

var stopPropagation = function stopPropagation(e) {
  return e.stopPropagation();
};

var _default = function _default(_ref, cellProps) {
  var render = _ref.render,
      rtl = _ref.rtl,
      collapsed = _ref.collapsed,
      toggleGroup = _ref.toggleGroup,
      style = _ref.style,
      size = _ref.size;
  size = size || 18;
  style = style ? _objectSpread(_objectSpread({}, DEFAULT_STYLE), style) : DEFAULT_STYLE;
  var domProps = {
    onMouseDown: toggleGroup,
    onClick: stopPropagation,
    style: style
  };
  var result;

  if (render) {
    domProps.style = _objectSpread({}, domProps.style);
    result = render(domProps, _objectSpread(_objectSpread({}, cellProps), {}, {
      collapsed: collapsed,
      toggleGroup: toggleGroup,
      size: size
    }));

    if (result != undefined) {
      return result;
    }
  }

  if (collapsed) {
    return _react.default.createElement("svg", (0, _extends2.default)({}, domProps, {
      height: size,
      viewBox: "0 0 24 24",
      width: size
    }), rtl ? _react.default.createElement("path", {
      d: "M15.41 16.59L10.83 12l4.58-4.59L14 6l-6 6 6 6 1.41-1.41z"
    }) : _react.default.createElement("path", {
      d: "M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"
    }));
  }

  return _react.default.createElement("svg", (0, _extends2.default)({}, domProps, {
    height: size,
    viewBox: "0 0 24 24",
    width: size
  }), _react.default.createElement("path", {
    d: "M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6z"
  }));
};

exports.default = _default;